import { api } from "./customers";
export interface Customer {
  tipsTitle: string;
  tipsDescription: string;
  wellnessImage: any;
  categoryChoosen: number;
  scheduleDate: any;
  id: number;
}
export interface DashboardCustomersResponse {
  status: string;
  message: string;
  total_count: number;
  total_pages: number;
  current_page: number;
  data: Customer[];
  per_page: number;
  prev_page: number;
  nextPage: number;
}
export interface AppinmentById {
  status: string;
  message: string;
  data: Customer[];
}
type DasboardCustomersResponse = DashboardCustomersResponse[];
type AppoinmentByidResponse = AppinmentById[];

export const WellnessTipsApi = api.injectEndpoints({
  endpoints: (build) => ({
    getWellnessTipsList: build.query<DasboardCustomersResponse, any>({
      query: (pagi) =>
        `wellness_tips?page=${pagi?.pageNo}&fromDate=${
          pagi?.date?.startDate ? pagi?.date?.startDate : ""
        }&toDate=${
          pagi?.date?.endDate ? pagi?.date?.endDate : ""
        }&name=${pagi?.name}&category=${pagi?.source}`,
      providesTags: (result) =>
        result
          ? [
              ...result?.["data"]?.map(({ id }) => ({
                type: "DasboardCustomers" as const,
                id,
              })),
              { type: "DasboardCustomers", id: "LIST" },
            ]
          : [{ type: "DasboardCustomers", id: "LIST" }],
    }),
    getWellnessTipsbyId: build.query<AppoinmentByidResponse, any>({
      query: (id) => `wellness_tips/${id}`,
      providesTags: ["Reports"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    addWellnessTips: build.mutation<any, Partial<any>>({
      query: (body: any) => ({
        url: `wellness_tips`,
        method: "POST",
        body,
      }),
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    updateWellnessTips: build.mutation<void, Partial<any>>({
      query: ({ id, form_data }) => ({
        url: `wellness_tips/${id}`,
        method: "PUT",
        body: form_data,
      }),
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    addWellnessCategory: build.mutation<
      any,
      Partial<any>
    >({
      query: (body: any) => ({
        url: `wellness_category`,
        method: "POST",
        body,
      }),
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    updateWellnessCategory: build.mutation<void, Partial<any>>({
      query: ({ id, ...patch }) => ({
        url: `wellness_category/${id}`,
        method: "PUT",
        body: patch,
      }),
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
    getWellnessCategory: build.query<AppoinmentByidResponse, any>({
      query: (pagi) => pagi?.name!==undefined?`wellness_category?filter=${pagi?.name}`:`wellness_category?filter=`,
      providesTags: ["Reports"],
      transformResponse: (
        response: { data: AppoinmentByidResponse },
        meta,
        arg
      ) => response.data,
    }),
    getWellnessCategoryList: build.query<AppoinmentByidResponse, any>({
      query: (pagi) => `wellness_category_page?page=${pagi?.pageNo}&filter=${pagi?.name}`,
     
    }),
    deleteWellnessCategory: build.mutation<
      { success: boolean; id: number },
      number
    >({
      query(id) {
        return {
          url: `wellness_category/${id}`,
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "DashBoardLeads", id: "LIST" }],
    }),
  }),
});
export const {
  useGetWellnessTipsListQuery,
  useAddWellnessTipsMutation,
  useGetWellnessCategoryListQuery,
  useUpdateWellnessTipsMutation,
  useGetWellnessTipsbyIdQuery,
  useDeleteWellnessCategoryMutation,
  useAddWellnessCategoryMutation,
  useGetWellnessCategoryQuery,
  useUpdateWellnessCategoryMutation
} = WellnessTipsApi;
